import { injectable } from 'inversify'

import { User } from '../protocols/User'
import { BaseState } from './BaseState'

export interface AuthStateProps {
  token: string
  user: User
  /** Capabilities do usuário no Account (ex.: `product:planningapp`). */
  capabilities: string[]
}

const INITIAL_STATE: AuthStateProps = {
  token: null,
  user: null,
  capabilities: []
}

@injectable()
export class AuthState extends BaseState<AuthStateProps> {
  constructor() {
    super(INITIAL_STATE)
  }

  setToken(token: string) {
    this._updateStateProp('token', token)
  }

  /**
   * Grava `user` e `capabilities` numa emissão só: eles vêm juntos de `GET /v2/users/me`. Não emite quando
   * nada mudou, porque a checagem periódica do `Authenticator` refaz essa busca a cada 5 minutos e todo
   * assinante do estado reagiria à toa (o `TrackingService`, por exemplo, reidentifica o usuário no
   * Amplitude a cada emissão).
   */
  setAccount(user: User, capabilities: string[]) {
    const current = this.getStateSnapshot()
    // O `user` só tem primitivos e `Date`, e o mapper monta as chaves sempre na mesma ordem.
    if (
      JSON.stringify({ user: current.user, capabilities: current.capabilities }) ===
      JSON.stringify({ user, capabilities })
    ) {
      return
    }

    this.updateState({ user, capabilities })
  }
}
